import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import AppPermissionsFilter from "../../components/filters/AppPermissionsFilter/AppPermissionsFilter";
import AppPermissionsFilterResult from "../../components/filters/AppPermissionsFilter/AppPermissionsFilterResult";
import type { IAppsPermissionsFilter } from "../../types/commonFiltersDto";
import type { IAppsPermissionsDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

const createPermissionsFilter = (permissionsDescription: IAppsPermissionsDescriptionDto): SearchFilterInstance => ({
    key: "permissions",
    trackingName: "App Permissions",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.permissions.title" },
    tooltipText: { key: "si.find_apps.filters.permissions.tooltip" },
    filter: new FilterPanelBaseFilter<IAppsPermissionsFilter, IAppsPermissionsDescriptionDto>({
        options: permissionsDescription,
    }),
    filterView: AppPermissionsFilter,
    filterResultView: AppPermissionsFilterResult,
});

export default createPermissionsFilter;
